import { mockBuilder } from '../../utils/builderHelper.es.js';
import { generateId } from '../../utils/generateId.es.js';
import { aPrice } from '../Price.mock.es.js';
import { ReleaseAssetRoyalty } from './ReleaseAssetRoyalty.es.js';
import { aTrend } from './Trend.mock.es.js';
import { aSplitVersion } from './SplitVersion.mock.es.js';

/** @module Mocks */ /** typedoc */
function aReleaseAssetRoyalty() {
    return mockBuilder(new ReleaseAssetRoyalty())
        .withId(generateId('asset_stats_id', 1))
        .withName(generateId('asset_stats_name', 1))
        .withEarning(aPrice())
        .withTrend(aTrend())
        .withSplit(aSplitVersion());
}

export { aReleaseAssetRoyalty };
